import React from 'react';
import ReactDOM from 'react-dom/client';
import Root from './Root';
import './styles.css';

const el = document.getElementById('root');
if (!el) throw new Error('#root introuvable');

ReactDOM.createRoot(el).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
